// ============================================
// src/components/home/HeroButtons.tsx
// ============================================
import { Box, Button } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';

interface HeroButton {
  text: string;
  href: string;
  variant: 'contained' | 'outlined';
  icon?: React.ReactNode;
}

interface HeroButtonsProps {
  buttons?: HeroButton[];
}

export default function HeroButtons({ buttons }: HeroButtonsProps) {
  const defaultButtons = buttons || [
    {
      text: 'Comenzar Ahora',
      href: '/servicios',
      variant: 'contained' as const,
      icon: <TrendingUp />,
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      {defaultButtons.map((button, index) => (
        <Button
          key={index}
          variant={button.variant}
          size="large"
          href={button.href}
          startIcon={button.icon}
          sx={{
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2,
            ...(button.variant === 'contained' && {
              boxShadow: '0 4px 14px 0 rgba(30, 64, 175, 0.39)',
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
                boxShadow: '0 6px 20px rgba(30, 64, 175, 0.5)',
              },
            }),
            ...(button.variant === 'outlined' && {
              borderWidth: 2,
              borderColor: 'white',
              color: 'white',
              '&:hover': {
                borderWidth: 2,
                borderColor: 'white',
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              },
            }),
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              transform: 'translateY(-2px)',
            },
          }}
        >
          {button.text}
        </Button>
      ))}
    </Box>
  );
}